export default __webpack_public_path__ + "locales/ro/InviteDialog.json?hash=a114e905e55d9ec70b59b690adc390c4";